var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.tcls,attrs:{"id":"home"}},[_c('fui-top',{attrs:{"user":_vm.user,"themes":_vm.tcls},on:{"resetThemes":_vm.resetThemes}}),_c('fui-content',{ref:"fctt"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }